import { pad } from '@/utils/string'

export const makeQueryString = (
  params: Record<string, string | number | boolean | undefined | null>
): string => {
  const queryString = Object.entries(params)
    .filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join('&')
  return queryString !== '' ? `?${queryString}` : ''
}

export const getPageNameFromPathName = (pathname: string): string => {
  if (pathname.includes('checkout')) {
    return 'checkout'
  }

  if (pathname.includes('invoice')) {
    return 'invoice'
  }

  if (pathname.includes('loyalty')) {
    return 'loyalty'
  }

  if (pathname.includes('orders')) {
    return 'orders'
  }

  if (pathname.includes('privacy')) {
    return 'privacy'
  }

  if (pathname.includes('reservations')) {
    return 'reservations'
  }

  if (pathname.includes('stores')) {
    return 'stores'
  }

  if (pathname.includes('terms')) {
    return 'terms'
  }

  if (pathname.includes('thankyou')) {
    return 'thankyou'
  }

  if (pathname.includes('user')) {
    return 'user'
  }

  return 'index'
}

export const getServerDomain = (url?: string): string | undefined =>
  url?.replace(/(^\w+:|^)\/\//, '')

export const dateToRequestString = (
  input?: Date | string
): string | undefined => {
  if (!input) return undefined
  const date = input instanceof Date ? input : new Date(input)
  return `${date.getDate()} ${pad(
    String(date.getMonth() + 1)
  )} ${date.getFullYear()}`
}

export const createUrl = (_url: string): string => {
  const url = _url || '/'
  return url.startsWith('#') ||
    url.startsWith('?') ||
    url.startsWith('/') ||
    url.includes('://')
    ? url
    : `http://${url}`
}

export const getCurrentPage = ({
  path,
}: {
  path: string | string[]
}): string => {
  const currentPath = Array.isArray(path) ? path : [path]
  return currentPath[0] || 'index'
}

// Modern browser-only utilities for Next.js client components
export const isBrowser = (): boolean => typeof window !== 'undefined'

export const getUrlObject = (): URL | null => {
  if (!isBrowser()) return null
  try {
    return new URL(window.location.href)
  } catch {
    return null
  }
}

// Modern version using URLSearchParams for Next.js App Router
export const consumeQueryParam = (name: string): string | null => {
  if (!isBrowser()) return null

  const url = new URL(window.location.href)
  const value = url.searchParams.get(name)

  if (value) {
    url.searchParams.delete(name)
    window.history.replaceState(null, '', url.toString())
  }

  return value
}

// Utility to parse search params from URLSearchParams (Next.js App Router compatible)
export const parseSearchParams = (
  searchParams: URLSearchParams
): Record<string, string> => {
  const params: Record<string, string> = {}
  searchParams.forEach((value, key) => {
    params[key] = value
  })
  return params
}

// Utility to build URL with search params
export const buildUrlWithParams = (
  pathname: string,
  params: Record<string, string | number | boolean | undefined | null>
): string => {
  const queryString = makeQueryString(params)
  return `${pathname}${queryString}`
}
